<template>
  <div class="award_content">
    <div class="award_ranking">
      <div class="department">
        <div class="timeRadio">
          <el-button type="primary" size="mini" @click="getMonth"
            >本月</el-button
          >
          <el-date-picker
            v-model="dateVal"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="timeChange"
            size="mini"
          >
          </el-date-picker>
        </div>
        <div id="manageId"></div>
      </div>
      <div class="department">
        <div class="timeRadio">
          <el-button type="primary" size="mini" @click="getMonthone"
            >本月</el-button
          >
          <el-date-picker
            v-model="dateValone"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="timeChangeone"
            size="mini"
          >
          </el-date-picker>
        </div>
        <div id="oneselfId"></div>
      </div>
    </div>
    <div class="award_table">
      <div class="table_title">学习榜样明细</div>
      <div class="table_form">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="姓名">
            <el-input
              size="mini"
              v-model="formInline.searchName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="所属部门">
            <el-input
              size="mini"
              v-model="formInline.departmentName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="获奖日期">
            <el-date-picker
              v-model="awardDateVal"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="awardChange"
              size="mini"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" type="primary" @click="onSubmit"
              >查询</el-button
            >
            <el-button size="mini" @click="reset">重置</el-button>
            <el-button size="mini" @click="open = true">新增</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table_menu">
        <el-table :data="tableData" border style="width: 100%" height="300">
          <el-table-column label="序号" type="index" align="center" width="50">
          </el-table-column>
          <el-table-column align="center" prop="name" label="姓名" width="180">
          </el-table-column>
          <el-table-column
            align="center"
            prop="departmentName"
            label="所属部门"
            width="180"
          >
          </el-table-column>
          <el-table-column align="center" prop="content" label="日行一善内容">
          </el-table-column>
          <el-table-column align="center" prop="reason" label="获奖理由">
          </el-table-column>
          <el-table-column align="center" prop="date" label="获奖日期">
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        @current-change="changePage"
        :page-size.sync="queryParams.pageSize"
        :current-page.sync="queryParams.pageNum"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="新增个人获奖"
      :visible.sync="open"
      width="600px"
      append-to-body
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="姓名" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="所属部门" prop="departmentName">
          <el-input v-model="ruleForm.departmentName"></el-input>
        </el-form-item>
        <el-form-item label="日行一善内容" prop="content">
          <el-input type="textarea" v-model="ruleForm.content"></el-input>
        </el-form-item>
        <el-form-item label="获奖理由" prop="reason">
          <el-input type="textarea" v-model="ruleForm.reason"></el-input>
        </el-form-item>
        <el-form-item label="活动时间" required>
          <el-form-item prop="date">
            <el-date-picker
              placeholder="选择日期"
              v-model="ruleForm.date"
              type="date"
              format="yyyy-MM-dd"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >提交</el-button
          >
          <el-button @click="open = false">取消</el-button>
        </el-form-item>
      </el-form></el-dialog
    >
  </div>
</template>

<script>
import * as echarts from "echarts";
import moment from "moment";
import {
  getexportDepartmentData,
  getAwardList,
  addAwardList,
  getDepartmentAwards,
  getEmployeeAwards
} from "@/api/doOneGood";
export default {
  name: "Statistical",
  data() {
    return {
      xAxisList: [],
      chartsData: [],
      onexAxisList: [],
      onechartsData: [],
      myChart: "",
      oneselfChart: "",
      dateVal: "",
      dateValone: "",
      formInline: {
        searchName: null,
        departmentName: null
      },
      tableData: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      awardDateVal: [],
      ruleForm: {},
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        departmentName: [
          { required: true, message: "请输入所属部门", trigger: "blur" }
        ],
        content: [
          { required: true, message: "请输入日行一善内容", trigger: "blur" }
        ],
        reason: [
          { required: true, message: "请输入获奖理由", trigger: "blur" }
        ],
        date: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ]
      },
      day: moment().format("YYYY-MM-DD"),
      startTime: moment()
        .startOf("month")
        .format("YYYY-MM-DD"),
      endTime: moment()
        .endOf("month")
        .format("YYYY-MM-DD"),
      open: false,
      page: 1
    };
  },
  mounted() {
    this.awardDateVal[0] = this.day;
    this.awardDateVal[1] = this.day;
    this.getList();
    setTimeout(() => {
      this.getdepartInfo();
      this.getEmployeeAwardsInfo();
      // this.initEcharts();
      // this.initOneself();
    }, 1000);
  },
  methods: {
    submitForm(ruleForm) {
      this.$refs[ruleForm].validate(async valid => {
        if (valid) {
          const { data, code } = await addAwardList(this.ruleForm);
          if (code === "0") {
            this.$message.success("添加成功！");
          } else this.$message.error("添加失败！");
          this.open = false;
          this.ruleForm = {};
          this.getList();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    async getList() {
      let params = {
        startTime: this.awardDateVal[0],
        endTime: this.awardDateVal[1],
        searchName: this.formInline.searchName,
        departmentName: this.formInline.departmentName,
        page: this.queryParams.pageNum
      };
      const { data, code } = await getAwardList(params);
      if (code === "0") {
        this.tableData = data.data;
        this.total = data.total;
      }
    },
    handleClose() {
      this.open = false;
      this.form = {};
    },
    reset() {
      this.formInline = {};
      this.awardDateVal = [];
      this.awardDateVal[0] = this.day;
      this.awardDateVal[1] = this.day;
      this.getList();
    },
    add() {},
    onSubmit() {
      this.getList();
    },
    initEcharts() {
      var chartDom = document.getElementById("manageId");
      var chartsOption = {
        title: {
          text: "部门获奖排名"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: this.xAxisList,
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              fontSize: 8
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            name: "次数",
            minInterval:1
          }
        ],
        series: [
          {
            name: "得分",
            type: "bar",
            barWidth: "60%",
            data: this.chartsData,
            type: "bar",
            showBackground: true,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#83bff6" },
                { offset: 0.5, color: "#188df0" },
                { offset: 1, color: "#188df0" }
              ])
            }
          }
        ]
      };
      this.myChart = echarts.init(chartDom);
      chartsOption && this.myChart.setOption(chartsOption);
    },
    initOneself() {
      var chartDom = document.getElementById("oneselfId");
      var chartsOption = {
        title: {
          text: "个人获奖排名"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: this.onexAxisList,
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              fontSize: 8
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            name: "次数",
            minInterval:1
          }
        ],
        series: [
          {
            name: "（得分）",
            type: "bar",
            barWidth: "60%",
            data: this.onechartsData,
            type: "bar",
            showBackground: true,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#83bff6" },
                { offset: 0.5, color: "#188df0" },
                { offset: 1, color: "#188df0" }
              ])
            }
          }
        ]
      };
      this.oneselfChart = echarts.init(chartDom);
      chartsOption && this.oneselfChart.setOption(chartsOption);
    },
    getMonth() {
      this.startTime = moment()
        .startOf("month")
        .format("YYYY-MM-DD");
      this.endTime = moment()
        .endOf("month")
        .format("YYYY-MM-DD");
      this.getdepartInfo();
    },
    getMonthone() {
      this.startTime = moment()
        .startOf("month")
        .format("YYYY-MM-DD");
      this.endTime = moment()
        .endOf("month")
        .format("YYYY-MM-DD");
      this.getEmployeeAwardsInfo();
    },
    timeChange(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      this.getdepartInfo();
    },
    timeChangeone(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      this.getEmployeeAwardsInfo();
    },
    awardChange(val) {},
    async getdepartInfo() {
      const params = {
        startTime: this.startTime,
        endTime: this.endTime
      };
      const { code, data } = await getDepartmentAwards(params);
      if (code != "0") return;
      this.xAxisList = data.map(el => {
        return el.departmentName;
      });
      this.chartsData = data.map(el => {
        return el.total;
      });
      this.initEcharts();
      // this.myChart.setOption({
      //   xAxis: [{ data: this.xAxisList }],
      //   series: [{ data: this.chartsData }],
      // });
    },
    async getEmployeeAwardsInfo() {
      const params = {
        startTime: this.startTime,
        endTime: this.endTime
      };
      const { code, data } = await getEmployeeAwards(params);
      if (code != "0") return;
      this.onexAxisList = data.map(el => {
        return el.employeeName ? el.employeeName : "未知";
      });
      this.onechartsData = data.map(el => {
        return el.total;
      });
      this.initOneself();
      // this.oneselfChart.setOption({
      //   xAxis: [{ data: this.onexAxisList }],
      //   series: [{ data: this.onechartsData }],
      // });
    },
    changePage(val) {
      this.queryParams.pageNum = val;
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped>
.award_content {
  width: 100%;
  height: 380px;
  .award_ranking {
    display: flex;
    width: 100%;
    height: 380px;

    .department {
      width: 50%;
      position: relative;
      .timeRadio {
        position: absolute;
        right: 16%;
      }
      #manageId {
        width: 90%;
        height: 100%;
        margin-top: 16px;
      }
      #oneselfId {
        width: 90%;
        height: 100%;
        margin-top: 16px;
      }
    }
  }
  .award_table {
    width: 100%;
    height: 380px;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .table_title {
      width: 100%;
      font-weight: 600;
      font-size: 18px;
      color: #333;
    }
    .table_form {
      width: 70%;
    }
    .table_menu {
      width: 90%;
      height: 380px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OneGoodModule/AwardRanking.vue